import { Suspense } from 'react';
import { Link, useLocation } from 'react-router-dom';
import "./Header.css";
import SearchButton from "./SearchButton";
import { useAuth0 } from "@auth0/auth0-react"; 
import AuthenticatedContent from './AuthenticatedContent.tsx';

const Header = () => {

  const { isAuthenticated, loginWithRedirect } = useAuth0(); // Хуки для авторизации
  const location = useLocation(); // Получаем текущий путь
  const currentPath = location.pathname; // Текущий URL

  return (
    <div id="header">
      <div className="header">
        
      <div className="header_top">
        
      <SearchButton />
      
      <span
          className="achtzehn" 
          title="18+" aria-label="18+">🔞</span>

      <Link to="/kinotheater"
          className={`kinotheater ${currentPath.startsWith('/kinotheater') ? 'active' : ''}`} 
          title="LUZIFER" aria-label="LUZIFER">😈</Link>
    
      <a className="marafon" href="https://vk.com/theatermavrodi" title="МАРАФОН" aria-label="МАРАФОН" target="_blank">🦉</a>

      <Link to="/auslandsamt" 
          className={`auslandsamt ${currentPath.startsWith('/auslandsamt') ? 'active' : ''}`} 
          title="AUSLANDSAMT" aria-label="AUSLANDSAMT">🌐</Link>


        {/* кнопка "Личный кабинет" */}
          {isAuthenticated ? (
          <Link
            to="/lk"
            className="demo_but"
            aria-label="Перейти в Личный кабинет"
            title="Перейти в Личный кабинет"
          >ЛИЧНЫЙ КАБИНЕТ</Link>
           ) : (
          <button
            className="demo_but"
            onClick={() => loginWithRedirect()}
            aria-label="Войти в Личный кабинет"
            title="Войти в Личный кабинет"
            role="button"
          >ЛИЧНЫЙ КАБИНЕТ</button>
        )}

      </div>

      <div className="header_bot">
<Link to="/museum" className={`hex_btn raz ${currentPath.startsWith('/museum') ? 'active' : ''}`}
          aria-label="Перейти в раздел Музей"
        >МУЗЕЙ</Link>
{/* <img src="/images/portrait.webp" alt="Сергей Мавроди" width="88" height="101"/> */}
           <a className="none" href="https://sergey-mavrodi.com">
            <h1>Официальный сайт Сергея Мавроди</h1>        
          </a>
<Link to="/wos" className={`hex_btn dva ${currentPath.startsWith('/wos') ? 'active' : ''}`}
          aria-label="Перейти в раздел Закон"
        >ЗАКОН</Link>
      </div>
      
      <div className="main_menu">
        <Link
          to="/news"
          className={`main_menu_link zwei ${currentPath.startsWith('/news') ? 'active' : ''}`}
          aria-label="Перейти в раздел Новости"
        >
          НОВОСТИ
        </Link>
        <Link
          to="/schriftstellerei"
          className={`main_menu_link drei ${currentPath.startsWith('/schriftstellerei') ? 'active' : ''}`}
          aria-label="Перейти в раздел Творчество"
        >
          ТВОРЧЕСТВО
        </Link>
        <Link
          to="/bewertungen"
          className={`main_menu_link vier ${currentPath.startsWith('/bewertungen') ? 'active' : ''}`}
          aria-label="Перейти в раздел Отзывы"
        >
          ОТЗЫВЫ
        </Link>
        <Link
          to="/privacy"
          className={`main_menu_link eins ${currentPath.startsWith('/privacy') ? 'active' : ''}`}
          aria-label="Перейти в раздел Феникс"
        >
          ФЕНИКС
        </Link>
      </div>
          
      {/* <div className="banner-wrap">
      <Link
        to="/contacts"
        className={`banner ${currentPath.startsWith('/contacts') ? 'active' : ''}`} 
        aria-label="Перейти на страницу Контакты">К   О   Н   Т   А   К   Т   Ы</Link></div> */}


      {/* <div className="banner">
        <a href="/https://sergeymavrodi.com"></a>
      </div> */}

{isAuthenticated && (
        <Suspense fallback={<div>...</div>}>
          <AuthenticatedContent />
        </Suspense>
      )}

      </div>
    </div>
  );
};

export default Header;
